/* @flow */

import moment from 'moment';

import { type LogAtivacao } from '../../empresa/types';
import { type StateColors } from '../../utils/types';

const getColor = (ativo: 0 | 1): StateColors => (ativo ? 'success' : 'danger');

const SEM_MOTIVO = 'Sem motivo';

const linhaTempoLogAtivacao = (logs: LogAtivacao[]) => `
<div class="m-timeline-3">
    <div class="m-timeline-3__items">
        ${logs.map(log => `
            <div class="m-timeline-3__item m-timeline-3__item--${getColor(log.ativo)}">
                <span
                    class="m-timeline-3__item-time"
                    data-toggle="m-tooltip"
                    title="${moment(log.entrada).format('LLLL')}">
                    ${moment(log.entrada).format('DD/MM')}
                </span>
                <div class="m-timeline-3__item-desc">
                    <span class="m-timeline-3__item-text">
                        ${log.ativo ? 'Ativado' : 'Desativado'}: ${log.motivo || SEM_MOTIVO}
                    </span>
                    <br>
                    <span class="m-timeline-3__item-user-name">
                        <a href="#" class="m-link m-link--metal m-timeline-3__item-link">
                            ${moment(log.entrada).format('LLLL')}
                        </a>
                    </span>
                </div>
            </div>
        `).join('')}
    </div>
</div>
`;

export default linhaTempoLogAtivacao;
